import { request } from "@shared/utils";
import { API, METHODS } from "@shared/constants";
import { EvalRunListFilter } from "@shared/interfaces";

import { RunEvalFromCsvDto } from "../interface";

export default {
  // The list endpoint is 1-based, the app's pagination is 0-based.
  getEvalRuns: ({ page, limit }: EvalRunListFilter) =>
    request(METHODS.GET, API.EVAL.GET_RUNS)({ params: { page: page + 1, limit } }),
  getEvalRun: (uuid: string) => request(METHODS.GET, API.EVAL.GET_RUN(uuid))(),
  deleteEvalRun: (uuid: string) => request(METHODS.DELETE, API.EVAL.DELETE_RUN(uuid))(),
  runEvalFromCsv: (payload: RunEvalFromCsvDto) => request(METHODS.POST, API.EVAL.RUN_CSV)(payload),
  getEvalTemplate: () => request(METHODS.GET, API.EVAL.GET_TEMPLATE)(),
  getEvalCategories: () => request(METHODS.GET, API.EVAL.GET_CATEGORIES)(),
};
